<template>
	<div class="realName home_bg">
		<Header></Header>
		<div style="width: 100%;height: 80px;"></div>
		<div class="main">
			<div class="wx_box">
				<div class="wx_main">
					<div class="top">
						<div class="wx_title fl">
							<span>企业设置</span>
						</div>
					</div>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
						<div class="form">
							<div class="item">
								<div class="label">企业首页显示名字</div>
								<div class="input">
									<el-form-item label="" prop="truename">
										<el-input v-model="ruleForm.truename" placeholder="请输入显示名字"></el-input>
									</el-form-item>
								</div>
								<div class="tips">提示:公司全称！</div>
							</div>
							<div class="item">
								<div class="label">法人姓名</div>
								<div class="input">
									<el-form-item label="" prop="law_person">
										<el-input v-model="ruleForm.law_person" placeholder="请输入法人姓名"></el-input>
									</el-form-item>
								</div>
								<div class="tips">提示：姓名全称</div>
							</div>
							<div class="item">
								<div class="label">注册资本</div>
								<div class="input">
									<el-form-item label="" prop="reg_money">
										<el-input v-model="ruleForm.reg_money" placeholder="请输入显示名字"></el-input>
									</el-form-item>
								</div>
								<div class="tips">提示：单位万元！</div>
							</div>
							<div class="item">
								<div class="label">注册时间</div>
								<div class="input">
									<el-form-item label="" prop="reg_day">
										<el-date-picker
										      v-model="ruleForm.reg_day"
										      type="date"
										      placeholder="选择日期">
										    </el-date-picker>
									</el-form-item>
								</div>
								<div class="tips">提示：公司成立时间，和营业执照上时间对应</div>
							</div>
							<div class="item">
								<div class="label">企业首页BANNER图片</div>
								<div class="flies">
									<div class="flie_fl">
										<el-form-item label="" prop="display_image">
											<el-upload :action="uploadAction" :headers="myHeaders"
												:on-success="handleDisplayImageSuccess"
												:before-upload="beforeDisplayImageUpload" :show-file-list="false"
												:file-list="displayImageList">
												<div class="positive">
													<img :src="ruleForm.display_image" v-if="displayImageList.length>0">
												</div>
											</el-upload>
										</el-form-item>
									</div>
								</div>
								<div class="tips">提示：只能上传一张jpg、png格式图片，大小尺寸为：1280*180.如果不传，为系统默认图片。</div>
							</div>
							<div class="item">
								<div class="label">企业简介文字</div>
								<div class="input">
									<el-form-item label="" prop="introduce">
										<el-input type="textarea" :autosize="{ minRows: 4}" v-model="ruleForm.introduce"
											placeholder="企业介绍文字，限300字！">


										</el-input>
									</el-form-item>
								</div>
								<div class="tips">注意：如果企业的法人、注册资金等信息有变更时，想在首页更新其信息，请点击重新企业认证！</div>
							</div>
						</div>
						<div class="btns">
							<el-button @click="updateShow = true">更新信息</el-button>
							<el-button @click="againShow = true" class="again">重新企业认证</el-button>
						</div>
					</el-form>
				</div>

			</div>

		</div>
		<!--        更新信息弹窗-->
		<WxMessageBox :show="updateShow" @save="updatesave" @canse="updatecanse">
			<div slot="content">
				<p class="word">您确定更新以上信息么？</p>
			</div>
		</WxMessageBox>
		<!--        重新企业认证弹窗-->
		<WxMessageBox :show="againShow" @save="againsave" @canse="againcanse">
			<div slot="content">
				<div class="word marTop">
					<p>您确定要重新企业认证么？</p>
					<p>在认证通过前，将不能新建园区，</p>
					<p>原有园区还是可以继续访问！</p>
				</div>
			</div>
		</WxMessageBox>
	</div>
</template>

<script>
	import {
		get_user_company,
		personCompanySet
	} from '@/api/api'
	import Header from '@/components/Header';
	import axios from 'axios';

	import WxMessageBox from '@/components/MessageBox';
	export default {
		name: "enterpriseSet",
		data() {
			return {

				title: '111',
				ruleForm: {
					truename: '',
					law_person: '',
					reg_money: '',
					reg_day: '',
					introduce: '',
					display_image: '',

				},
				rules: {
					truename: [{
						required: true,
						message: '请输入公司名称',
						trigger: 'blur'
					}],
					law_person: [{
						required: true,
						message: '请输入公司法人姓名',
						trigger: 'blur'
					}],
					reg_money: [{
						required: true,
						message: '请输入公司注册资本',
						trigger: 'blur'
					}],
					reg_day: [{
						required: true,
						message: '请选择公司注册时间',
						trigger: 'change'
					}],

				},

				displayImageList: [],
				display_image: '',
				uploadAction: axios.defaults.baseURL + "/upload/image",
				myHeaders: {
					authorization: "Bear " + localStorage.getItem("token")
				},
				updateShow: false,
				againShow: false,

			}
		},
		created() {
			this.get_user_company()
		},
		methods: {
			get_user_company() {
				get_user_company().then(resp => {
					this.displayImageList.push({
						url: resp.info.display_image
					})
					this.ruleForm = resp.info

				})
			},
			// 企业首页BANNER图片
			handleBannerSuccess(res, file) {
				this.bannerUrl = URL.createObjectURL(file.raw);
			},
			beforeBannerUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPng = file.type === 'image/png';
				if (!isJPG && !isPng) {
					this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
				}
				return isJPG;
			},
			// 更新信息弹窗确定
			updatesave() {
				this.$refs["ruleForm"].validate((valid) => {
					console.log(valid)
					if (valid) {
						personCompanySet(this.ruleForm).then(resp => {
							console.log(resp)
							this.$message.success(resp)
							//this.get_user_company();

						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				this.updateShow = false
			},
			// 更新信息弹窗取消
			updatecanse() {

				this.updateShow = false
			},
			// 重新企业认证弹窗确定
			againsave() {
				this.againShow = false
				this.$router.push('/attestation/company');
			},
			// 重新企业认证弹窗取消
			againcanse() {

				this.againShow = false

			},
			handleDisplayImageSuccess(res, file) {
				this.displayImageUrl = URL.createObjectURL(file.raw);
				this.ruleForm["display_image"] = res.data;
				this.displayImageList.push(res.data)
			},
			beforeDisplayImageUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPng = file.type === 'image/png';
				if (!isJPG && !isPng) {
					this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
					return false
				} else {
					return true
				}
			},
		},
		components: {
			Header,
			WxMessageBox
		}
	}
</script>

<style lang="less">
	.realName {
		.main {
			padding: 0 30px 60px 30px;

			.wx_box {
				.wx_main {
					padding: 10px 0 80px 17px;
					background: radial-gradient(rgba(19, 62, 173, 0.74), rgba(5, 18, 32, 0.47));
					background-size: cover;

					.top {
						width: 100%;
						float: left;
						padding-bottom: 20px;
					}

					.form {
						width: 1000px;
						margin: 0 auto;

						.label {
							font-size: 18px;
							color: #fff;
							padding: 22px 0 15px 0;
						}

						.input {
							.el-input__inner {
								background-color: rgba(45, 153, 255, 0.3);
								border: 0;
								border-radius: 0;
								color: #C0C0C0;
								font-size: 16px;
							}

							.el-textarea__inner {
								background-color: rgba(45, 153, 255, 0.3);
								border: 0;
								border-radius: 0;
								color: #fff;
								font-size: 16px;
							}
						}

						.tips {
							font-size: 14px;
							color: #858FA9;
							padding-top: 8px;
						}

						.flies {
							display: flex;
							justify-content: space-between;
							flex-wrap: wrap;

							.flie_fl {
								width: 1000px;
								height: 141px;

								.positive {
									width: 1000px;
									height: 141px;
									background: url("../../assets/images/home/fileBanner.png") no-repeat;
									background-size: cover;
									display: flex;
									justify-content: center;
									align-items: center;
								}

								img {
									width: 980px;
									height: 120px;
								}
							}
						}
					}

					.btns {
						width: 1000px;
						padding-top: 55px;
						display: flex;
						justify-content: space-between;
						margin: 0 auto;

						.el-button {
							width: 480px;
							height: 48px;
							background: #2D99FF;
							font-size: 18px;
							font-weight: 400;
							color: #fff;
							border: 0;
							border-radius: 0;
						}

						.again {
							background: #00A1E6;
						}
					}
				}
			}
		}

		.word {
			margin-top: 88px;
		}

		.marTop {
			margin-top: 65px;
		}
	}
</style>
